<template>
  <div id="app">
    <nav class="navbar">
      <div class="wrapper container">
        <div class="col">
          <a class="navbar-brand" href="#"><img src="./assets/logo.png" alt="Cyclonis Screen Capture" /></a>
        </div>
        <div class="col">
          <a :href="downloadURL" class="btn-download-a">
            <div class="btn-download">
              <img src="./assets/icon-download.svg" alt="Download Cyclonis Screen Capture">
              <dl>
                <dd>Download Cyclonis Screen Capture</dd>
                <dt>It's FREE!</dt>
              </dl>
            </div>
          </a>
        </div>
      </div>
    </nav>
    <transition name="router-fade" mode="out-in">
      <router-view @titleChange="updateTitle"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      title: this.$route.meta.title,
      downloadURL: process.env.VUE_APP_DOWNLOAD_URL
    }
  },
  methods: {
    updateTitle(value) {
      this.title = value
    }
  }
}
</script>

<style lang="scss">
</style>
